import { Report } from "@/types/Report";
import { cx } from "@/utils";
import AccessControl from "@components/AccessControl";
import Clickable, { ClickableProps } from "@components/Clickable";

import styles from "./NewWidgetButton.module.css";

type NewWidgetButtonProps = {
  size?: number;
  templateName: Report["template"];
  className?: string;
} & ClickableProps;

const NewWidgetButton: React.FunctionComponent<NewWidgetButtonProps> = ({
  className,
  templateName,
  onClick,
  ...rest
}) => {
  return (
    <div className={templateName === "time_comparison" ? "ml-auto" : ""}>
      <AccessControl>
        <Clickable
          className={cx(styles.root, "h4", className)}
          {...rest}
          onClick={(e) => {
            e.preventDefault();
            onClick?.(e);
          }}
        >
          {L.REPORTS_WIDGET_NEW_TITLE}
        </Clickable>
      </AccessControl>
    </div>
  );
};

export default NewWidgetButton;
